<form [formGroup]="form" class="pb-16px">
  <div class="text-center italic mb-36px mt-16px md:mt-16px">
    <div class="text-center px-24px text-secondary">
      Congratulations <span class="capitalize">{{ formS.userName }}</span
      >!
    </div>
    <div class="text-center mt-16px px-24px">
      You are just one step away from creating your
      <span class="capitalize">{{ formS.accountType }}</span> account.
    </div>

    <hr class="border-border-l my-24px" />
    <div class="text-center mt-16px px-24px">
      Please provide your Banking details below to complete registration.
    </div>
  </div>
  <ib-mat-form-field-wrap
    class="sm:w-1/2"
    [formCtrlName]="SIGN_UP_FIELDS.ACCOUNT_BANK_CURRENCY"
    [formCtrl]="formS.currencyBankAbstractFormCtrl"
    [isSelect]="true"
    [isSelectDropdownOpen]="currency.isDropdownOpen"
  >
    <ib-currency
      #currency
      [parentForm]="form"
      [initByIp]="false"
      title="Account Currency"
      [formCtrl]="formS.currencyBankFormCtrl"
      [showPlaceholder]="false"
      class="block w-full"
    ></ib-currency>
  </ib-mat-form-field-wrap>

  <ib-mat-form-field-wrap
    [formCtrlName]="SIGN_UP_FIELDS.ACCOUNT_HOLDER_NAME"
    [formCtrl]="form.get(SIGN_UP_FIELDS.ACCOUNT_HOLDER_NAME)"
    [showClearBtn]="true"
  >
    <mat-form-field>
      <mat-label>Account Holder Name</mat-label>
      <input
        matInput
        (keydown.enter)="submitFromInput($event)"
        formControlName="{{ SIGN_UP_FIELDS.ACCOUNT_HOLDER_NAME }}"
        required
      />
    </mat-form-field>
  </ib-mat-form-field-wrap>

  <ib-mat-form-field-wrap
    [formCtrlName]="SIGN_UP_FIELDS.ACCOUNT_IBAN"
    [formCtrl]="form.get(SIGN_UP_FIELDS.ACCOUNT_IBAN)"
    [showClearBtn]="true"
  >
    <mat-form-field>
      <mat-label>IBAN</mat-label>
      <input
        matInput
        (keydown.enter)="submitFromInput($event)"
        formControlName="{{ SIGN_UP_FIELDS.ACCOUNT_IBAN }}"
        required
      />
    </mat-form-field>
  </ib-mat-form-field-wrap>
</form>
